<div
  class="col th-p pos-relative groutchat-content-wrapper"
  appDragDrop
  (dropHandler)="onDropHandler($event)"
  [ngClass]="{
    'chat-detail-bg': userSettings.default_layout,
    'hide-chat': hidechatContent
  }"
>
  <header class="top-box-shadow">
    <div class="chats" style="width: 100%">
      <div class="content-wrapper is-clearfix">
        <div class="chat-name row">
          <!-- Single user part  -->
          @if (!is_group_chat && selectedUserDetail.first_name &&
          !beforeUserDetails) {
          <div class="is-pulled-left col-7">
            <!-- <div class="is-pulled-left" *ngIf="this.chatListComponent.viewChatList; else ifNotShow">
              <div class="is-pulled-left has-tooltip-left hideMobileView" data-tooltip="Show ChatList">
                <i class="fa is-pulled-left fa-angle-double-right" (click)="hideChatList()"></i>
              </div>
            </div>
            <ng-template #ifNotShow>
              <div class="is-pulled-left has-tooltip-left hideMobileView" data-tooltip="Hide ChatList">
                <i class="fa is-pulled-left fa-angle-double-left" (click)="hideChatList()"></i>
              </div>
            </ng-template> -->
            @if (!selectedUserDetail.user_icon) {
            <empty-uname
              [userName]="selectedUserDetail.first_name"
              [detailHeadProfile]="true"
            ></empty-uname>
            } @if (selectedUserDetail.user_icon) {
            <img
              [src]="profileUrl + selectedUserDetail.user_icon"
              class="is-pulled-left"
            />
            }
            <span class="chat-title-name is-size-6 mar-5-0">
              {{
                selectedUserDetail.first_name +
                  " " +
                  selectedUserDetail.last_name
              }}</span
            >
          </div>
          } @if (!is_group_chat && beforeUserDetails) {
          <div class="col-7 is-pulled-left has-tooltip-left">
            <!-- <div class="is-pulled-left" *ngIf="this.chatListComponent.viewChatList; else ifNotShow">
            <div class="is-pulled-left has-tooltip-left hideMobileView" data-tooltip="Show ChatList">
              <i class="fa is-pulled-left fa-angle-double-right" (click)="hideChatList()"></i>
            </div>
          </div>
          <ng-template #ifNotShow>
            <div class="is-pulled-left has-tooltip-left hideMobileView" data-tooltip="Hide ChatList">
              <i class="fa is-pulled-left fa-angle-double-left" (click)="hideChatList()"></i>
            </div>
          </ng-template> -->
            <empty-uname
              [userName]="changedUserData.full_name"
              [detailHeadProfile]="true"
            ></empty-uname>
            <span class="chat-title-name is-size-6 mar-5-0">
              {{ changedUserData.full_name }}</span
            >
          </div>
          }

          <!-- Group name part  -->
          @if (is_group_chat && selectedGroupDetail.chat_group_name) {
          <div class="col-7 is-pulled-left has-tooltip-left">
            <!-- <div class="is-pulled-left" *ngIf="this.chatListComponent.viewChatList; else ifNotShow">
          <div class="is-pulled-left has-tooltip-left hideMobileView" data-tooltip="Show ChatList">
            <i class="fa is-pulled-left fa-angle-double-right" (click)="hideChatList()"></i>
          </div>
        </div>
        <ng-template #ifNotShow>
          <div class="is-pulled-left has-tooltip-left hideMobileView" data-tooltip="Hide ChatList">
            <i class="fa is-pulled-left fa-angle-double-left" (click)="hideChatList()"></i>
          </div>
        </ng-template> -->
            <span class="pos-relative group-img-edit">
              @if (!selectedGroupDetail.chat_group_icon) {
              <empty-uname
                [userName]="selectedGroupDetail.chat_group_name"
                [detailHeadProfile]="true"
              ></empty-uname>
              } @if (selectedGroupDetail.chat_group_icon) {
              <img
                [src]="profileUrl + selectedGroupDetail.chat_group_icon"
                class="is-pulled-left"
              />
              } @if (selectedGroupDetail.can_edit) {
              <span class="img-options">
                <div class="dropdown is-hoverable">
                  <div class="dropdown-trigger">
                    <i class="fa fa-camera"></i>
                  </div>
                  <div class="dropdown-menu" id="dropdown-menu4" role="menu">
                    <div class="dropdown-content">
                      @if (!selectedGroupDetail.chat_group_icon) {
                      <a class="dropdown-item">
                        <label class="file-label">
                          <input
                            class="file-input"
                            name="profile"
                            id="profile"
                            type="file"
                            (change)="
                              changeGroupIcon(
                                $event,
                                selectedGroupDetail.chat_group_id
                              )
                            "
                            [disabled]="groupIconFileList.length > 0"
                            #fileInput
                          />
                          <span class="file-label">Add Picture</span>
                        </label>
                      </a>
                      } @if (selectedGroupDetail.chat_group_icon) {
                      <a
                        class="dropdown-item"
                        (click)="
                          deleteChatGroupIcon(selectedGroupDetail.chat_group_id)
                        "
                      >
                        <label for="" class="file-label">
                          <span class="file-label">Remove Picture</span>
                        </label>
                      </a>
                      }
                    </div>
                  </div>
                </div>
              </span>
              }
            </span>
            @if (!editGroupDetails) {
            <span
              class="chat-title-name hideMobileView is-size-6 mar-5-0 ellipsis"
              style="max-width: 80%"
              >{{ selectedGroupDetail.chat_group_name }}</span
            >
            } &nbsp;&nbsp;@if (!editGroupDetails &&
            selectedGroupDetail.can_edit) {
            <a
              class="has-text-info has-tooltip-right"
              data-tooltip="Edit"
              (click)="editGroupName()"
            >
              <i class="pi pi-pen-to-square pad-15-2"></i>
            </a>
            }
            <!-- Post name update section -->
            @if (editGroupDetails) {
            <span class="control control-edit-icon edit-text-box">
              <input
                type="text"
                class="input"
                inputFocus
                placeholder="Type here..."
                size="{{ calcTextLength(editGroupDetails.chat_group_name) }}"
                [(ngModel)]="editGroupDetails.chat_group_name"
                (keyup.enter)="updateChatGroup(editGroupDetails)"
              />
              <div class="options">
                <a class="button is-small" (click)="cancelEditedGroupName()"
                  >Cancel</a
                >
                <a
                  class="button is-link is-small mar-0-10"
                  (click)="updateChatGroup(editGroupDetails)"
                  >Save</a
                >
              </div>
            </span>
            }
          </div>
          }

          <div class="col-5 is-marginless is-clearfix is-pulled-right">
            <div class="is-pulled-right mar-10-0 chat-tab">
              <!-- <a class="pad-10 has-tooltip-left" (click)="callAudioInput()" *ngIf="activeUrl === 'singleuser' && !audioCallStart" data-tooltip="Phone">
          <i class="fa fa-phone is-size-6" aria-hidden="true" ></i>
        </a> -->
              <!-- <a class="is-small pad-10" (click)="showGroupUserList()" *ngIf="!audioCallStart">
        <i class="fa fa-info-circle is-size-6" aria-hidden="true"></i>
      </a> -->
              @if (!audioCallStart && activeUrl !== 'singleuser') {
              <a
                class="is-small pad-10 has-tooltip-left"
                [ngClass]="{ active: isActiveTabName == 'users' }"
                (click)="showUserInformation('users')"
                data-tooltip="Users"
              >
                <i class="pi pi-users is-size-6" aria-hidden="true"></i>
              </a>
              } @if (!audioCallStart) {
              <a
                class="is-small pad-10 has-tooltip-left"
                (click)="showUserInformation('files')"
                data-tooltip="E Library"
              >
                <i
                  class="fa fa-file-archive-o is-size-6"
                  aria-hidden="true"
                ></i>
              </a>
              } @if (!audioCallStart) {
              <a
                class="is-small pad-10 has-tooltip-left"
                (click)="showUserInformation('links')"
                data-tooltip="Links"
              >
                <i class="fa fa-link is-size-6" aria-hidden="true"></i>
              </a>
              }
              <!-- <a class="is-small pad-10 has-tooltip-left" *ngIf="!audioCallStart" (click)="showUserInformation('tasks')" data-tooltip="Assignment">
      <i class="fa fa-thumb-tack is-size-6" aria-hidden="true" ></i>
    </a> -->
              <a
                class="is-small pad-10 has-tooltip-left mobileViewBtn"
                (click)="hideSingleChat()"
                data-tooltip="Close"
              >
                <i class="fa fa-times is-size-6" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  @if (!audioCallStart) {
  <div class="contents is-marginless" [style.height]="100 + '%'">
    <div
      #chatArea
      class="chats scroll-bar"
      appInfiniteScroll
      (reachedTop)="onScrollUp($event)"
    >
      <pagination-loader
        [showFetchLoader]="showPaginateSpinner"
      ></pagination-loader>
      @if (getMessageList.length==0) {
      <div class="empty-state">
        <div class="common-empty topic-notify">
          <article class="media">
            <div class="media-content has-text-centered">
              <!-- <img [src]="'../../../../assets/images/chat_empty.svg'" /> -->
              <p>Let's Start To Type...</p>
            </div>
          </article>
        </div>
      </div>
      } @if (!userSettings.default_layout) {
      <div class="chat-list mar-0-15">
        <app-normal-view
          [messageList]="getMessageList"
          [loggedUserId]="loggedUserId"
        ></app-normal-view>
      </div>
      } @if (userSettings.default_layout) {
      <div class="chat-list msg-list-view">
        <app-list-view
          [messageList]="getMessageList"
          [loggedUserId]="loggedUserId"
        ></app-list-view>
      </div>
      }
    </div>
  </div>
  } @if (audioCallStart) {
  <div class="contents is-marginless">
    <!-- <app-audio-view (audioHandler)="audioCallStop($event)" [audioInput]="selectedUserDetail" [callResponse]="meetingPanel" [userDetails] = "send_user_detail"></app-audio-view> -->
    <app-audio-view
      (audioHandler)="audioCallStop($event)"
      [audioInput]="selectedUserDetail"
    ></app-audio-view>
  </div>
  } @if (!audioCallStart) {
  <footer class="chats">
    @if (!is_group_chat) {
    <div class="field is-grouped">
      <!-- <div class="control has-icons-left has-icons-right is-expanded" *ngIf="selectedUserDetail.acc_active"> -->
      @if (isUserActivated) {
      <div class="control has-icons-left has-icons-right is-expanded">
        <!-- <input type="search" #messageInput class="input multiple"  inputFocus placeholder=" Type Message here..." [(ngModel)]="textMessage"
            (keyup.enter)="sendMessage(textMessage)" (keydown)="keyDownHandler($event)" (keyup)="keyUpEmit('user', true)" (blur)="keyUpEmit('user', false)"> -->
        <div
          aria-label="Type Message here..."
          dir="ltr"
          spellcheck="true"
          class="input multiple contenteditable scroll-bar"
          aria-multiline="true"
          contenteditable="true"
          data-emojiable="true"
          placeholder="Type Message here..."
          #messageInput
          (input)="textMessage = $event.target.innerHTML"
          (keyup.enter)="sendMessage(textMessage)"
          (keydown)="keyDownHandler($event)"
          (keyup)="keyUpEmit('user', true)"
          (blur)="keyUpEmit('user', false)"
          (keypress)="_wrapTextMessage($event)"
          (paste)="handleTextPaste($event)"
          (mouseenter)="cursorEndPosition($event)"
        ></div>
        <span
          class="icon is-small is-left first-icon has-tooltip-top"
          data-tooltip="Attach file"
          (click)="msgFileInput.click()"
        >
          <i class="pi pi-paperclip"></i>
        </span>
        <!-- <span class="icon is-small is-left second-icon">
            <i class="fa fa-microphone"></i>
            <i class="fa fa-weixin" (click)="toggleChatBotPanel()"></i>
          </span> -->
        <span
          class="icon is-small is-right has-tooltip-top"
          data-tooltip="Emoji"
        >
          <!-- <app-emoji (pickedEmoji)="getPickedEmoji($event)"></app-emoji> -->
          <app-emojimart (pickedEmoji)="getPickedEmoji($event)"></app-emojimart>
        </span>
      </div>
      }
      <!-- <div class="control">
      <a (click)="sendMessage(textMessage)" class="button is-link">
        <i class="fa fa-paper-plane"></i>
      </a>
    </div> -->
    </div>
    }
    <!-- <div class="columns up-btn-fix" *ngIf="!is_group_chat && !selectedUserDetail.acc_active"> -->
    @if (!is_group_chat) {
    <div class="columns up-btn-fix">
      @if (!isUserActivated) {
      <div class="column is-12 has-text-centered">
        <code class="has-text-danger">User has been deactivated</code>
      </div>
      }
    </div>
    } @if (is_group_chat) {
    <div class="field is-grouped">
      <div class="control has-icons-left has-icons-right is-expanded">
        <!-- <input type="search" #messageInput class="input" inputFocus placeholder=" Type Message here..." [(ngModel)]="textMessage" (keyup.enter)="sendGroupMessage(textMessage)" (keydown)="keyDownHandler($event)"
      (keyup)="keyUpEmit('group', true)" (blur)="keyUpEmit('group', false)"> -->
        <!-- <div aria-label="Type Message here..." spellcheck="true" dir="ltr" class="input multiple contenteditable" aria-multiline="true" contenteditable="true" placeholder="Type Message here..." #messageInput (input)="textMessage=$event.target.innerHTML" (keyup.enter)="sendGroupMessage(textMessage)" (keydown)="keyDownHandler($event)"
    (keyup)="keyUpEmit('group', true)" (blur)="keyUpEmit('group', false)" (keypress)="_wrapTextMessage($event)" style="text-align: left;" (paste)="handleTextPaste($event)" (mouseenter)="cursorEndPosition($event)"></div> -->
        <div
          aria-label="Type Message here..."
          spellcheck="true"
          dir="ltr"
          class="input multiple contenteditable"
          aria-multiline="true"
          contenteditable="true"
          placeholder="Type Message here..."
          #messageInput
          (input)="textMessage = $event.target.innerHTML"
          (keyup.enter)="sendGroupMessage(textMessage)"
          (keydown)="keyDownHandler($event)"
          (keyup)="keyUpEmit('group', true)"
          (blur)="keyUpEmit('group', false)"
          (keypress)="_wrapTextMessage($event)"
          style="text-align: left"
          (paste)="handleTextPaste($event)"
          (mouseenter)="cursorEndPosition($event)"
        ></div>
        <span
          class="icon is-small is-left first-icon has-tooltip-top"
          data-tooltip="Attach file"
          (click)="msgFileInput.click()"
        >
          <i class="pi pi-paperclip"></i>
        </span>
        <span
          class="icon is-small is-right has-tooltip-top"
          data-tooltip="Emoji icons"
        >
          <!-- <app-emoji (pickedEmoji)="getPickedEmoji($event)"></app-emoji> -->
          <app-emojimart (pickedEmoji)="getPickedEmoji($event)"></app-emojimart>
        </span>
      </div>
    </div>
    }
    <!-- Input file selection  -->
    <input
      type="file"
      name="msg-file"
      style="display: none"
      (change)="chooseUploadFile($event)"
      #msgFileInput
    />
  </footer>
  } @if (upLoadedFileList.length > 0) {
  <section class="accordions file-upload">
    <article
      class="accordion"
      [ngClass]="{ 'is-active': _domParams.hideFilePreview }"
    >
      <div class="accordion-header" (click)="toggleFilePreview()">
        <p>Attachement</p>
        <button class="toggle" aria-label="toggle"></button>
      </div>
      <div class="accordion-body">
        <div class="accordion-content">
          @for (eachFile of upLoadedFileList; track eachFile) {
          <div class="pos-relative">
            <figure class="image is-48x48">
              <img
                src="../../../../assets/images/file_types/{{
                  eachFile.mimeType
                }}.png"
              />
            </figure>
            <div class="file-detail">
              <div class="content-align">
                <p>{{ eachFile.name }}</p>
                <span class="file-size">{{ eachFile.size | fileSize }}</span>
                @if (eachFile.progressVal) {
                <progress
                  class="progress is-link is-small"
                  value="{{ eachFile.progressVal }}"
                  max="100"
                ></progress>
                }
              </div>
            </div>
            <i
              class="fa fa-times"
              aria-hidden="true"
              (click)="removeFileFromList(eachFile)"
            ></i>
          </div>
          }
        </div>
        <!-- <div class="d-flex justify-content-end">
        <span  (click)="sendAttachment()"><i class="pi pi-send"></i></span>
      </div>   -->
      </div>
    </article>
  </section>
  }
</div>
<div class="position-relative">
  <div class="chat-user-list">
    @if (_domParams.showUserList) {
    <app-group-userlist
      [audioUser]="audioTabShow"
      [isGroupChat]="is_group_chat"
      [userDetail]="selectedUserDetail"
      [groupDetail]="selectedGroupDetail"
      [events]="eventsSubject.asObservable()"
    ></app-group-userlist>
    }
  </div>
</div>
